import React from 'react';

export default function DeleteConfirmModal({ isOpen, title, message, onConfirm, onCancel, loading }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 1200 }}>
      <div className="modal" style={{ maxWidth: '28rem', padding: '2rem', borderRadius: '24px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '80px', 
            height: '80px', 
            borderRadius: '24px', 
            background: '#fff1f2', 
            color: '#e11d48', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            margin: '0 auto 1.5rem',
            transform: 'rotate(-5deg)'
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 6h18"></path>
              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </div>
          
          <h2 style={{ 
            fontFamily: 'var(--font-display)', 
            fontSize: '1.5rem', 
            fontWeight: 800, 
            color: '#0f172a', 
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em'
          }}>
            {title}
          </h2>
          
          <p style={{ 
            fontSize: '1rem', 
            color: '#64748b', 
            lineHeight: 1.6,
            marginBottom: '2rem'
          }}>
            {message}
          </p>
        </div>

        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button 
            type="button" 
            className="btn btn-ghost" 
            style={{ flex: 1, padding: '0.875rem' }} 
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            type="button" 
            className="btn btn-red" 
            style={{ 
              flex: 1, 
              padding: '0.875rem',
              background: '#e11d48',
              borderColor: '#e11d48',
              boxShadow: '0 4px 12px rgba(225, 29, 72, 0.25)'
            }} 
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center' }}>
                <span className="spinner" style={{ width: '1rem', height: '1rem', borderWidth: '2px' }} />
                Deleting...
              </span>
            ) : 'Yes, Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
